import { Header } from "./styled"

export const HeroTitle = () => {
  return (
    <Header>
      Invest in <b>yourself</b>
    </Header>
  )
}
